import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, modalActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, modalActions);

export default slice.reducer;
